import { useQuery } from "@tanstack/react-query";
import * as chatbotApi from "src/api/chatbot";
import type { ChatbotLimits } from "src/components/GlobalChatbot/types";
import { chatbotQueryKeys } from "src/hooks/chatbotQueryKeys";
import defaultOptions from "src/hooks/defaultOptions";

export function useChatbotLimits(enabled = true) {
	return useQuery<ChatbotLimits>({
		queryKey: chatbotQueryKeys.limits,
		queryFn: chatbotApi.getConversationLimits,
		...defaultOptions,
		enabled,
	});
}
